/** Display equivalents only. The report's numeric minutes remain unchanged. */
export function staffWorkDuration(minutes: number | null | undefined): string {
  if (minutes === null || minutes === undefined || !Number.isFinite(minutes)) { return 'Unavailable'; }
  if (minutes === 0) { return '0m'; }
  const sign = minutes < 0 ? '-' : '';
  const seconds = Math.round(Math.abs(minutes) * 60);
  if (!seconds) { return sign + '<1s'; }
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor(seconds % 3600 / 60);
  const secs = seconds % 60;
  return sign + [hours ? hours.toLocaleString('en-AU') + 'h' : '', mins ? mins + 'm' : '', secs ? secs + 's' : ''].filter(Boolean).join(' ');
}

/** A workweek is a display unit of five workdays, independent of date filters. */
export function staffWorkEquivalent(minutes: number | null | undefined, dailyMinutes: number | null | undefined): string {
  if (minutes === null || minutes === undefined || !Number.isFinite(minutes) || !Number.isFinite(dailyMinutes) || dailyMinutes <= 0) { return ''; }
  const dayMs = Math.round(dailyMinutes * 60000);
  const totalMs = Math.round(Math.abs(minutes) * 60000);
  if (!dayMs || totalMs < dayMs) { return ''; }
  const weeks = Math.floor(totalMs / (dayMs * 5));
  const days = Math.floor((totalMs % (dayMs * 5)) / dayMs);
  const remainderMs = totalMs % dayMs;
  const parts = [weeks ? weeks + ' workweek' + (weeks === 1 ? '' : 's') : '', days ? days + ' workday' + (days === 1 ? '' : 's') : '', remainderMs ? staffWorkDuration(remainderMs / 60000) : ''];
  return (minutes < 0 ? '-' : '') + parts.filter(Boolean).join(' ');
}

export function staffWorkTimeHint(minutes: number | null | undefined, dailyMinutes?: number | null): string {
  if (minutes === null || minutes === undefined || !Number.isFinite(minutes)) { return ''; }
  const equivalent = staffWorkEquivalent(minutes, dailyMinutes);
  return staffWorkDuration(minutes) + (equivalent ? ' / ' + equivalent : '');
}
